// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"154":"56b6befcbf9adee4","213":"52252fadff7a9d78","257":"98176fd9a6029079","365":"96ca27bcd720f8c3","438":"db0cecda301e6ba4","461":"863726fd3957e2bb","564":"4fcb993840f1866f","589":"23b2097148cc41b9","685":"55bf417f46263123","966":"535d17b7106dec1b"}[chunkId] + ".js";
};